import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../../data/product';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section aria-labelledby="faq-titulo" className="w-full border-t border-sand bg-ivory" data-id="element-79" data-mp="2fyccitwbz4f7">
      <div className="mx-auto grid max-w-6xl gap-6 px-6 py-12 md:gap-10 md:py-24 lg:grid-cols-12 lg:gap-12 lg:px-10 lg:py-32" data-id="element-80" data-mp="2g0p3fwk2gp4e">
        <div className="lg:col-span-4" data-id="element-81" data-mp="2px1xivjix4zo">
          <h2 id="faq-titulo" className="font-serif text-[30px] font-normal leading-[1.1] tracking-tight text-carbon lg:text-4xl" data-id="element-82" data-mp="2pw0hsdrkbubm">
            Antes de <em className="italic text-gold-ink" data-id="element-83" data-mp="2yp3ugjudw357">comenzar…</em>
          </h2>
          <p className="mt-3 max-w-xs text-base leading-normal text-stone" data-id="element-84" data-mp="2yqwzxvt9ghbm">
            Todo lo que necesitas saber sobre el libro y RESET 21.
          </p>
          <span className="mt-5 hidden h-0.5 w-10 bg-gold lg:block" aria-hidden="true" data-id="element-85" data-mp="38o2sl8hiwgdy" />
        </div>

        <ul className="border-t border-sand lg:col-span-7 lg:col-start-6" data-id="element-86" data-mp="18wgt5yi7pu8t">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <li key={faq.question} className="border-b border-sand" data-id="element-87" data-mp="1msk7sjglru06" data-mpi={index}>
                <h3 data-id="element-88" data-mp="1rthyxljlbydt">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="group flex min-h-[56px] w-full items-center justify-between gap-4 py-4 text-left text-[16px] font-medium leading-snug text-carbon focus:outline-none focus-visible:ring-2 focus-visible:ring-gold sm:text-lg" data-id="element-89" data-mp="1rrx21p9t03cs">
                    {faq.question}
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-gold text-gold-ink' : 'border-sand text-stone group-hover:border-gold'}`} data-id="element-90" data-mp="fgkxqwo2m1wn">
                      <Icon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="kf4javyr5boh" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-92" data-mp="u6ionkddx5pj">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-93" data-mp="u8lads7i8cog">
                      <p className="max-w-xl pb-5 pr-11 text-[15px] leading-relaxed text-stone sm:text-base" data-id="element-94" data-mp="1kh15zig0jl42">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}